<template>
    <div class="w-screen min-w-[100vw] bg-gray-700 min-h-screen md:flex  lg:grid lg:grid-cols-12">
        <Inboxs />
        <Messages :show-contact="user?.id == conversation?.agent_id && !conversation?.can_close" />
        <Contact v-if="user?.id == conversation?.agent_id && conversation &&  !conversation?.can_close" />
    </div>
</template> 
<script>
import Messages from '@/pages/messages/Index.vue';
import Contact from '@/pages/contact/Index.vue';
import Inboxs from '@/pages/inboxs/Index.vue';
import { mapFields } from 'vuex-map-fields';

export default {
    name:"InboxPage",
    components:{
        Messages,
        Inboxs,
        Contact
    },
    computed:{
        ...mapFields("conversations/show",{
            conversation:"item"
        }),
        ...mapFields("auth/user",{
            user:"item"
        })
    }
    
}
</script>